<template>
  <v-data-table
    :headers="headers"
    :options="{ itemsPerPage: 15 }"
    :items="items"
    sort-by="name"
    :search="search"
    class="elevation-0 general-table"
    @click:row="itemEdit"
    :loading="isLoading"
    :loading-text="$t('GLOBAL-LOADING-PLEASE_WAIT')"
  >
    <template v-slot:top>
      <div class="d-flex align-center flex-wrap py-2 mb-3">
        <v-text-field
          clearable
          class="general-table__search"
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          :label="$t('GLOBAL-DO_SEARCH')"
          solo
          flat
          dense
          hide-details
        >
        </v-text-field>

        <v-spacer></v-spacer>
      </div>
    </template>

    <template v-slot:footer.page-text="props" v-if="items.length > 0">
      <display-number :number="props.pageStart" />-<display-number :number="props.pageStop" /> {{ $t("of") }}
      <display-number :number="items.length" />
    </template>

    <template v-slot:header.name="{ header }">
      <lang t="HELP-TBL-HEADER-NAME"></lang>
    </template>

    <template v-slot:header.language="{ header }">
      <lang t="HELP-TBL-HEADER-LANG"></lang>
    </template>

    <template v-slot:item.actions="{ item }"></template>

    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import DisplayNumber from "../../../components/DisplayNumber.vue";
export default {
  name: "HelpBtnIndex",
  components: {
    DisplayNumber,
  },
  data: () => ({
    isSaving: false,
    isLoading: true,

    search: "",

    headers: [
      { text: "name", value: "name", align: "start", sortable: true, width: "320px" },
      { text: "", value: "actions", sortable: false, width: "80px" },
    ],

    languages: [],
    items: [],
  }),

  created() {
    this.initialize();
  },

  mounted() {},

  methods: {
    initialize() {
      this.isLoading = true;

      this.axios.get("helptexts").then((res) => {
        this.items = res.data;
        this.isLoading = false;
      });
    },

    itemEdit(item) {
      this.$router.push({ name: "helpEdit", params: { id: item.id } });
    },

    itemDelete(item) {
      return;
    },
  },
};
</script>

<style lang="scss"></style>
